import { render } from "./AccountDeactivateSection.vue?vue&type=template&id=2c90d5f2"
import script from "./AccountDeactivateSection.vue?vue&type=script&lang=js"
export * from "./AccountDeactivateSection.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__